export default "__VITE_ASSET__t94KPkr$__"